<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') ||
                '展会名称/编号/地点/负责人/参与人 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="140px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_expo_info_status') || '状态'">
              <el-checkbox-group v-model="form.expoInfoStatusList">
                <el-checkbox label="N">
                  {{ $l('btn_status_N') || '新增' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('btn_status_Y') || '已审核' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ $l('btn_status_D') || '已删除' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_expo_info_no') || '展会编号'"
              prop="expoInfoNo"
            >
              <el-input
                v-model.trim="form.expoInfoNo"
                clearable
                size="small"
                :placeholder="
                  $l('tips_input_expoInfoNo') || '请输入展会编号...'
                "
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_expo_info_name') || '展会名称'"
              prop="expoInfoName"
            >
              <el-input
                v-model.trim="form.expoInfoName"
                clearable
                size="small"
                :placeholder="
                  $l('tips_input_expoInfoName') || '请输入展会名称...'
                "
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_expo_info_address') || '展会地点'"
              prop="expoInfoAddress"
            >
              <el-input
                v-model.trim="form.expoInfoAddress"
                clearable
                size="small"
                :placeholder="
                  $l('tips_input_expoInfoAddress') || '请输入展会地点...'
                "
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_expo_manager_name') || '负责人'"
              prop="expoManagerCode"
            >
              <dict-select
                v-model="form.expoManagerCode"
                :selectedLabel.sync="form.expoManagerName"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('tips_select_expoManager') || '请选择负责人...'
                "
                size="small"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_participants') || '参与人'"
              prop="participantsArray"
            >
              <dict-select
                v-model="form.participantsArray"
                url="/master/common/dict/baseUserSelect"
                size="small"
                :placeholder="
                  $l('tips_select_participantsArray') || '请选择参与人...'
                "
                clearable
                filterable
                multiple
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_begin_date') || '开始日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('tips_select_begin_time') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('tips_select_begin_time') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_end_date') || '结束日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('tips_select_end_time') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('tips_select_end_time') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_created_date') || '创建时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_createDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_createDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_modifyDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_modifyDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  expoInfoStatusList: ['N', 'Y'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      addDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
